import React from 'react'
import { reduxForm } from 'redux-form'
import {
  makeStyles,
  Backdrop,
  CircularProgress,
  Input
} from '@material-ui/core'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

import { showAlertMessage } from '../store/alert/actions'
import { getChildrenRSPA } from '../store/classrooms/actions'
import { getPickupAuthorizations } from '../store/pickup/actions'
import { createPickupQueueRSPA } from '../store/pickup_queue/actions'

import UserAvatar from '../components/shared/UserAvatar'
import Button from '../components/button/Button'
import { relationOptions } from '../utils/constants'
import CustomTable from '../components/table/CustomTable'
import InputSelect from '../components/select/InputSelect'
import StyledSVG from '../components/shared/StyledSVG'
import crossAddSVG from '../assets/icons/cross-add-icon.svg'
import searchIcon from '../assets/icons/search-icon.svg'
import characterMagnifyingGlass from '../assets/icons/ilustration-character-with-magnifying-glass.svg'
import createQueueSuccessSVG from '../assets/icons/success-pickup-backdrop.svg'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '64px 32px',
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '96%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 8,
      '& path': {
        stroke: '#386093'
      },
      '& h1': {
        margin: 0,
        fontSize: 32,
        fontWeight: 700,
        color: '#386093'
      }
    }
  },
  authorize_pickup_btn: {
    backgroundColor: '#92CB5A',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#92CB5A'
    },
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 300
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 144
  },
  cross_add_wrapper: {
    width: 30,
    height: 30,
    borderRadius: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #264468',
    '& path': {
      fill: '#264468'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& h1': {
      margin: 0,
      fontSize: 32,
      fontWeight: 700,
      color: '#386093'
    }
  },
  search_component: {
    width: '325px',
    height: 40,
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  inputs_wrapper: {
    display: 'flex',
    columnGap: 32,
    alignItems: 'flex-start'
  },
  responsible_input_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    '& p': {
      margin: 0,
      fontWeight: 600,
      fontSize: 12
    }
  },
  input_wrapper: {
    width: 325
  },
  avatar_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    '& p': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555'
    }
  },
  table_root: {
    marginTop: 32
  },
  backdrop_icon_wrapper: {
    width: 400,
    height: 320,
    borderRadius: 24,
    backgroundColor: '#386093',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '32px 56px 48px 48px',
    rowGap: 16,
    '& .title': {
      margin: 0,
      color: '#F1F3F4',
      fontWeight: 600,
      fontSize: 24
    },
    '& .subtitle': {
      margin: 0,
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: 14
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  without_authorization_fallback: {
    marginTop: 52,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .fallback_description': {
      '& h1': {
        fontWeight: 600,
        fontSize: 20,
        margin: 0,
        marginBottom: 8
      },
      '& p': {
        color: '#7B7B7B',
        fontWeight: 500,
        fontSize: 12,
        margin: 0
      }
    }
  },
  img_wrapper: {
    width: 240,
    height: 270
  }
}))

const PickupManualPage = ({
  authorizations,
  getChildrenRSPA,
  getPickupAuthorizations,
  createPickupQueueRSPA,
  schoolId,
  currentUser,
  alert
}) => {
  const classes = useStyles()
  const history = useHistory()
  const [selectedChild, setSelectedChild] = React.useState([])
  const [responsibleName, setResponsibleName] = React.useState('')

  const [searchParams, setSearchParams] = React.useState({})
  const [backdrop, setBackdrop] = React.useState({ open: false, svg: null })

  const columns = [
    {
      key: 'name',
      name: 'Reponsável',
      width: '25%',
      render: row => {
        const parentData = {
          ...(row?.pickup_authorization?.user_id
            ? { name: row?.user?.name, photo: row?.user?.avatar_url }
            : { name: row?.name, photo: row?.photo_url })
        }
        return (
          <div className={classes.avatar_wrapper}>
            <UserAvatar
              avatarStyle={{
                width: 40,
                height: 40
              }}
              withoutUserName
              userName={parentData.name}
              avatarUrl={parentData.photo}
            />
            <p>{parentData.name}</p>
          </div>
        )
      }
    },
    {
      key: 'relationship_type',
      name: 'Vínculo',
      width: '12%',
      render: row => {
        return (
          <p>
            {
              relationOptions.find(item => item.value === row.relationship_type)
                .label
            }
          </p>
        )
      }
    },
    {
      key: 'taxpayer_number',
      name: 'CPF',
      width: '12%',
      render: row => {
        return <p>{row?.taxpayer_number}</p>
      }
    },
    {
      key: 'phone',
      name: 'Telefone',
      width: '12%',
      render: row => {
        return <p>{row?.phone}</p>
      }
    },
    {
      key: 'vehicle_plate',
      name: 'Placa',
      width: '10%',
      render: row => {
        return <p>{row?.vehicle_plate?.toUpperCase()}</p>
      }
    },
    {
      key: 'authorize_action',
      name: '',
      width: '16%',
      render: row => {
        return (
          <Button
            type='button'
            onclick={() => handleCreatePickupQueue(row)}
            className={classes.authorize_pickup_btn}
          >
            Autorizar saída
          </Button>
        )
      }
    }
  ]

  React.useEffect(
    () => {
      if (selectedChild.length > 0) {
        const params = {
          'q[children_id_eq]': selectedChild?.[0].id,
          'q[pickup_type_eq]': 1
        }
        setSearchParams(params)
        getPickupAuthorizations({
          params
        })
      }
    },
    [selectedChild]
  )

  const handleCreatePickupQueue = authorization => {
    setBackdrop(prev => ({ ...prev, open: true }))
    createPickupQueueRSPA({
      pickup_authorization_id: authorization.id,
      pickup_queue_children_attributes: [{ child_id: selectedChild?.[0].id }],
      status: 'finished',
      picked_at: moment(new Date()).format('DD/MM/YYYY HH:mm'),
      approved_by_id: currentUser.id
    })
      .then(res => {
        setBackdrop(prev => ({ ...prev, svg: createQueueSuccessSVG }))
      })
      .catch(err => {
        console.error(err)
        setBackdrop({ svg: null, open: false })
        alert('Erro ao concluir a retirada.', 'error')
      })
  }

  const handleChangeResponsibleName = event => {
    const name = event.target.value
    setResponsibleName(name)
    const params = {
      'q[children_id_eq]': selectedChild?.[0]?.id,
      'q[name_cont]': name,
      'q[pickup_type_eq]': 1,
      'q[m]': 'and'
    }
    setSearchParams(params)
    getPickupAuthorizations({
      params
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className='title'>
          <div className={classes.cross_add_wrapper}>
            <StyledSVG src={crossAddSVG} height={12} width={12} />
          </div>
          <h1>Retirada Manual</h1>
        </div>
        <Button
          type='button'
          onclick={() => history.goBack()}
          className={classes.go_back_btn}
        >
          Voltar
        </Button>
      </div>
      <p className='subtitle'>
        Realize a retirada manualmente pesquisando pelo nome do aluno.
      </p>
      <div className={classes.inputs_wrapper}>
        <InputSelect
          wrapperClass={classes.input_wrapper}
          fetchItems={getChildrenRSPA}
          selectedItems={selectedChild}
          setSelectedItems={setSelectedChild}
          placeholder={'Digite o nome completo do aluno'}
          label={'Buscar aluno'}
          params={{
            'page[size]': 7,
            'q[classroom_child_classroom_year_lteq]':
              new Date().getFullYear() + 1,
            'q[classroom_child_classroom_year_gteq]': new Date().getFullYear()
          }}
        />
        <div className={classes.responsible_input_wrapper}>
          <p>Responsável</p>
          <Input
            disableUnderline
            value={responsibleName}
            className={classes.search_component}
            placeholder='Busque pelo nome do responsável'
            onChange={e => handleChangeResponsibleName(e)}
            endAdornment={<StyledSVG src={searchIcon} width={18} height={18} />}
          />
        </div>
      </div>
      {selectedChild?.[0] || responsibleName.length > 0 ? (
        <CustomTable
          classRoot={classes.table_root}
          columns={columns}
          from={'authorizations'}
          noDataAlert={
            'Ninguém além dos responsáveis legais e com acesso ao aplicativo está autorizado a retirar a criança.'
          }
          data={authorizations.items}
          fetchItems={getPickupAuthorizations}
          params={searchParams}
          isFetching={authorizations.isFetching}
          pagination={authorizations.pagination}
          columnsPointer={[0]}
          border={'none'}
          headCellRadius
          headColor={'rgba(173, 184, 204, 0.3)'}
        />
      ) : (
        <div className={classes.without_authorization_fallback}>
          <img className={classes.img_wrapper} src={characterMagnifyingGlass} />
          <div className='fallback_description'>
            <h1>Configure os filtros para começar</h1>
            <p>Selecione o aluno ou o responsável para iniciar a busca</p>
          </div>
        </div>
      )}
      <Backdrop
        onClick={() => setBackdrop(prev => ({ svg: null, open: false }))}
        className={classes.backdrop}
        open={backdrop.open}
      >
        {backdrop.svg ? (
          <div className={classes.backdrop_icon_wrapper}>
            <StyledSVG width={120} height={110} src={createQueueSuccessSVG} />
            <h1 className='title'>Retirada Concluída</h1>
            <p className='subtitle'>
              {selectedChild?.[0]?.name} já está com o responsável. Tenha um
              ótimo dia!
            </p>
          </div>
        ) : (
          <CircularProgress />
        )}
      </Backdrop>
    </div>
  )
}
const mapStateToProps = (state, props) => ({
  authorizations: state.authorizations,
  schoolId: state.school?.currentSchool?.school_id,
  currentUser: state?.auth?.user?.data
})

const mapDispatchToProps = dispatch => ({
  getChildrenRSPA: data => dispatch(getChildrenRSPA.request(data)),
  getPickupAuthorizations: data => dispatch(getPickupAuthorizations(data)),
  createPickupQueueRSPA: data => dispatch(createPickupQueueRSPA.request(data)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
  // change: (field, data) => dispatch(change('announcementsForm', field, data)),
  // submit: () => dispatch(submit('announcementsForm'))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'ManualAuthorizationPage'
    // enableReinitialize: true,
    // touchOnChange: true,
    // touchOnBlur: true,
  })(PickupManualPage)
)
